import { C, PAGE, inr, label, newBrandedDoc } from "./pdfKit";

const fmtDate = (iso) => new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });

export const downloadReceiptPdf = async (b) => {
  const doc = await newBrandedDoc("Issued");
  const { M, R } = PAGE;
  const p = b.payment || {};
  const ok = !!p.verified;

  label(doc, ok ? "SITE VISIT RECEIPT  ·  PAYMENT CONFIRMED" : "SITE VISIT RECEIPT  ·  PROVISIONAL", M, 52);
  doc.setFont("Cormorant", "normal"); doc.setFontSize(30); doc.setTextColor(C.INK);
  doc.text("Thank you — your visit is booked.", M, 63);
  doc.setFont("Plex", "normal"); doc.setFontSize(7.5); doc.setTextColor(C.MUTED);
  doc.text(`Receipt ${b.receipt_no}   ·   Booking ${b.booking_id}   ·   ${fmtDate(p.reported_at || b.created_at)}`, M, 70);

  // amount card
  const cy = 78, ch = 44;
  doc.setFillColor(C.INK); doc.rect(M, cy, R - M, ch, "F");
  label(doc, ok ? "PAID ONLINE VIA RAZORPAY" : "PAID VIA UPI", M + 8, cy + 10, C.GOLD);
  doc.setFont("Cormorant", "normal"); doc.setFontSize(34); doc.setTextColor(C.PAPER);
  doc.text(inr(p.amount || b.pay_now), M + 8, cy + 26);
  doc.setFont("Plex", "normal"); doc.setFontSize(8); doc.setTextColor("#a8a29e");
  doc.text(ok ? `Payment ${p.payment_id}   ·   ${p.instrument || "online"}   ·   order ${p.order_id}` : `UTR / reference ${p.utr || "—"}${p.upi_app ? `   ·   ${p.upi_app}` : ""}   ·   to ${b.upi_payee} (${b.upi_id})`, M + 8, cy + 35);
  [["Status", ok ? "Confirmed" : "Pending confirmation"], ["Balance due", b.balance ? `${inr(b.balance)} before leaving site` : "Nil"]].forEach(([k, v], i) => {
    const yy = cy + 12 + i * 14;
    label(doc, k.toUpperCase(), R - 8, yy, "#a8a29e", "right");
    doc.setFont("Jakarta", "bold"); doc.setFontSize(9); doc.setTextColor(i === 0 ? (ok ? "#7bc8a4" : C.GOLD) : C.PAPER); doc.text(v, R - 8, yy + 5, { align: "right" });
  });

  // client + visit
  let y = cy + ch + 14;
  const colW = (R - M - 10) / 2;
  const kv = (x, title, rows) => {
    label(doc, title, x, y);
    rows.forEach(([k, v], i) => {
      const yy = y + 8 + i * 9;
      doc.setFont("Plex", "normal"); doc.setFontSize(6.5); doc.setTextColor(C.MUTED); doc.text(k.toUpperCase(), x, yy);
      doc.setFont("Jakarta", "normal"); doc.setFontSize(9); doc.setTextColor(C.INK); doc.text(doc.splitTextToSize(v || "—", colW), x, yy + 4);
    });
  };
  kv(M, "BILLED TO", [["Name", b.name], ["Phone", b.phone], ["Email", b.email]]);
  kv(M + colW + 10, "VISIT", [["Location", b.place], ["Preferred date", fmtDate(b.visit_date)], ["Site address", b.site_address || "To be shared by phone"]]);
  y += 8 + 3 * 9 + 8;

  // fee lines
  label(doc, "FEE BREAKDOWN", M, y); y += 6;
  doc.setDrawColor(C.INK); doc.setLineWidth(0.4); doc.line(M, y, R, y); y += 6;
  b.lines.forEach((l) => {
    doc.setFont("Jakarta", "normal"); doc.setFontSize(9); doc.setTextColor(C.INK);
    doc.text(doc.splitTextToSize(l.label, 130), M, y);
    doc.setFont("Plex", "normal"); doc.text(inr(l.amount), R, y, { align: "right" });
    y += 6; doc.setDrawColor(C.RULE); doc.setLineWidth(0.25); doc.line(M, y, R, y); y += 6;
  });
  doc.setFont("Jakarta", "bold"); doc.setFontSize(9.5); doc.text("Total fee", M, y); doc.setFont("Plex", "normal"); doc.text(inr(b.total), R, y, { align: "right" }); y += 7;
  doc.setFont("Jakarta", "bold"); doc.setTextColor(C.GREEN); doc.text("Paid now", M, y); doc.setFont("Plex", "normal"); doc.text(inr(p.amount || b.pay_now), R, y, { align: "right" }); y += 7;
  if (b.balance) { doc.setFont("Jakarta", "bold"); doc.setTextColor(C.INK); doc.text("Balance before leaving site", M, y); doc.setFont("Plex", "normal"); doc.text(inr(b.balance), R, y, { align: "right" }); y += 7; }

  y += 8;
  label(doc, "PLEASE NOTE", M, y);
  doc.setFont("Jakarta", "normal"); doc.setFontSize(8.5); doc.setTextColor(C.INK);
  doc.text(doc.splitTextToSize(ok ? `Your payment is confirmed. We will call you within one working day to fix the visit time. ${b.note}` : `This provisional receipt records the UPI reference you shared. We confirm every payment against our Axis Bank statement within one working day and then call you to fix the visit time. ${b.note}`, R - M), M, y + 6, { lineHeightFactor: 1.5 });

  doc.save(`Carvings-Site-Visit-Receipt-${b.receipt_no}.pdf`);
};
